export default "__VITE_ASSET__CyF6u8jp__"